import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Tag,
  Card,
  Spin,
  Tabs,
  Avatar,
  Modal,
  Descriptions,
  Button,
  Typography,
  message,
} from "antd";
import { useParams, Link } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

function VehiclesDetail() {
  const { id } = useParams();
  const [vehicleData, setVehicleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  useEffect(() => {
    fetchVehicleData();
  }, [id]);

  const fetchVehicleData = async () => {
    try {
      const response = await axios.get(`http://93.127.203.113:5005/vehicles/${id}`);
      setVehicleData(response.data);
    } catch (error) {
      message.error("Unable to load vehicle details");
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = (src) => {
    setPreviewImage(src);
    setPreviewVisible(true);
  };

  const renderImage = (src, alt) => (
    src ? (
      <img
        src={`http://93.127.203.113:5005${src}`}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          borderRadius: "10px",
          cursor: "pointer",
        }}
        onClick={() => handlePreview(`http://93.127.203.113:5005${src}`)}
      />
    ) : (
      <Avatar
        shape="square"
        icon={<UserOutlined />}
        style={{
          width: "100%",
          height: "300px",
          borderRadius: "10px",
        }}
      />
    )
  );

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Vehicle Details
          </Title>
          <Tabs defaultActiveKey="1">
            <TabPane tab="Overview" key="1">
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card bordered={false} title="Vehicle Information">
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Plate Number">
                        {vehicleData?.plateNumber || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Model">
                        {vehicleData?.model || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Color">
                        {vehicleData?.color || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Manufactured Year">
                        {vehicleData?.manufacturedYear || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Status">
                        {vehicleData?.status || "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
                <Col span={24} md={12}>
                  <Card bordered={false} title="Vehicle Type Information">
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Type Name">
                        {vehicleData?.vehicle_type?.typeName || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Price Per KM">
                        {vehicleData?.vehicle_type?.pricePerKM || "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Surge Price Per KM">
                        {vehicleData?.vehicle_type?.surgePricePerKM || "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
              </Row>
            </TabPane>

            <TabPane tab="Driver" key="2">
              <Card bordered={false} title="Driver Information">
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Name">
                    {vehicleData?.driver
                      ? `${vehicleData.driver.firstName} ${vehicleData.driver.lastName}`
                      : "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone Number">
                    {vehicleData?.driver?.phoneNumber || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Status">
                    {vehicleData?.driver?.status ? (
                      <Tag
                        color={
                          vehicleData.driver.status === "Active"
                            ? "green"
                            : "red"
                        }
                      >
                        {vehicleData.driver.status.toUpperCase()}
                      </Tag>
                    ) : (
                      "N/A"
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            <TabPane tab="Owner" key="3">
              <Card bordered={false} title="Owner Information">
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Name">
                    {vehicleData?.owner?.name || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contact">
                    {vehicleData?.owner?.contact || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Email">
                    {vehicleData?.owner?.email || "N/A"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            <TabPane tab="Vehicle Documents" key="4">
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Card bordered={false} title="Images and Documents">
                    {renderImage(vehicleData?.vehicleImage, "Vehicle Image")}
                    {renderImage(vehicleData?.documents, "Vehicle Documents")}
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Card>
      )}

      <Modal
        visible={previewVisible}
        title="Image Preview"
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
}

export default VehiclesDetail;
